export const getQuickLinks = ({
  hasCpanel,
  hasAdvancedHosting,
  hasRootWhm,
  isPlesk,
  isWindows,
  isReseller,
}: any) => {
  const listButtonLinks = [
    {
      name: 'whm',
      type: 'vps',
      canShow: hasRootWhm,
      queryParams: {
        app: 'whm',
      },
    },
    {
      name: 'systemconsole',
      type: 'vps',
      canShow: hasAdvancedHosting && !isPlesk && !isWindows,
      queryParams: {
        app: 'systemconsole',
      },
    },
    {
      name: 'cpanel',
      type: 'hosting',
      canShow: hasCpanel && !isReseller && !hasAdvancedHosting,
    },
    {
      name: 'filemanager',
      type: 'hosting',
      canShow: hasCpanel && !isReseller && !hasAdvancedHosting,
      queryParams: {
        app: 'filemanager',
      },
    },
    {
      name: 'resellerwhm',
      type: 'reseller',
      canShow: isReseller,
      queryParams: {
        app: 'resellerwhm',
      },
    },
    {
      name: 'resellercpanel',
      type: 'reseller',
      canShow: hasCpanel && isReseller,
      queryParams: {
        app: 'resellercpanel',
      },
    },
    {
      name: 'adminpanel',
      type: 'plesk',
      canShow: isPlesk,
    },
  ];
  return listButtonLinks.filter((item) => item.canShow);
};
